import React from 'react';
import { Grid, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Title from '../../Components/Labels/Title';

const ExemptionHeader = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.headerContainer} alignItems="center">
        <Grid item sm={10} xs={9} className={classes.headerItemLeft}>
          <Title title="Exención de Contribución" />
        </Grid>
      </Grid>
      <Divider className={classes.separator} />
    </>
  );
};

const useStyles = makeStyles(theme => ({
  separator: { marginBottom: 30 },
  headerContainer: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3.5)
  },
  headerItemLeft: {
    display: 'flex',
    justifyContent: 'flex-start'
  }
}));

export default ExemptionHeader;
